import { abortAllRequests, liveRequests, trackRequest } from "../request-queue"; // TKP-254

export default {
  moduleName: "requestQueue",
  namespaced: true,

  state: () => ({}),
  getters: {
    controllers() {
      return liveRequests();
    },
  },
  mutations: {},
  actions: {
    add(_context, controller) {
      trackRequest(controller);
    },
    abortAll() {
      abortAllRequests();
    },
  },
};
